import React, { Component } from 'react';

import PropTypes from 'prop-types';

import Card from '../../Components/Card';

import {
  GetDateValue,
} from '../../Util/Properties';

class ProjectGroupCard extends Component {
  render() {
    const {
      ProjectGroup,
      style,
      height,
      onCardAction,
      onSelect,
      selected,
      isSearchResults,
    } = this.props; 
   
    let metadata = [];

    metadata.push(["Created", GetDateValue(ProjectGroup.CreatedOn)]);

    return (
      <Card
        style={style}
        height={height}
        onCardAction={onCardAction}
        onSelect={onSelect}
        selected={selected}
        minHeight={132}
        name={ProjectGroup.Name}
        metadata={metadata}
        isSearchResults={isSearchResults}
        contentItem={ProjectGroup}
      />
    );
  }
}

ProjectGroupCard.propTypes = {
  ProjectGroup: PropTypes.object.isRequired,
  onCardAction: PropTypes.func.isRequired,
};

export default ProjectGroupCard;